import { render, staticRenderFns } from "./SuccessAlert.vue?vue&type=template&id=7296a0a3&scoped=true&"
import script from "./SuccessAlert.vue?vue&type=script&lang=ts&"
export * from "./SuccessAlert.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessAlert.vue?vue&type=style&index=0&id=7296a0a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7296a0a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
